import * as enLang from '@amcharts/amcharts4/lang/en_US';
import * as noLang from '@amcharts/amcharts4/lang/nb_NO';
import * as svLang from '@amcharts/amcharts4/lang/sv_SE';
import * as fiLang from '@amcharts/amcharts4/lang/fi_FI';
import * as daLang from '@amcharts/amcharts4/lang/da_DK';
import * as csLang from '@amcharts/amcharts4/lang/cs_CZ';
import * as esLang from '@amcharts/amcharts4/lang/es_ES';
import * as skLang from '@amcharts/amcharts4/lang/sk_SK';

export let en = enLang;
export let no = noLang;
export let sv = svLang;
export let fi = fiLang;
export let da = daLang;
export let cs = csLang;
export let es = esLang;
export let sk = skLang;
